export default __webpack_public_path__ + "static/logo-d72c824664869f7ef2c4fba5626382fa.svg";